function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeltaBusinessText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 613.34 106.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6,74.85c0,9.7-3.28,17.1-9.83,22.2-6.55,5.1-15.53,7.65-26.92,7.65H0V1.2h24c10.4,0,18.32,2.33,23.78,6.98,5.45,4.65,8.17,10.93,8.17,18.82,0,10.8-5.25,18.35-15.75,22.65,13.6,3.8,20.4,12.2,20.4,25.2ZM45.75,27.45c0-5.5-1.85-9.75-5.55-12.75-3.7-3-9.2-4.5-16.5-4.5h-13.5v36h13.2c7.1,0,12.6-1.73,16.5-5.17,3.9-3.45,5.85-7.97,5.85-13.58ZM50.4,75.45c0-6.9-2.3-12.08-6.9-15.53-4.6-3.45-11.05-5.17-19.35-5.17h-13.95v40.95h14.55c7.9,0,14.15-1.77,18.75-5.33,4.6-3.55,6.9-8.52,6.9-14.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.25,65.25c0,12.6-3.5,22.6-10.5,30-7,7.4-16.55,11.1-28.65,11.1s-21.45-3.68-28.35-11.03-10.35-17.12-10.35-29.33V1.2h10.35v63.45c0,9.9,2.42,17.77,7.28,23.62,4.85,5.85,11.92,8.77,21.22,8.77s16.28-2.82,21.22-8.47c4.95-5.65,7.43-13.42,7.43-23.33V1.2h10.35v64.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.1,77.4c0,8.7-3.03,15.63-9.08,20.77-6.05,5.15-13.72,7.73-23.03,7.73-10.1,0-19.25-2.15-27.45-6.45l1.5-10.5c8.1,5.2,16.9,7.8,26.4,7.8,6.2,0,11.3-1.67,15.3-5.02,4-3.35,6-7.88,6-13.58,0-5.1-1.5-9.2-4.5-12.3-3-3.1-8.45-6.4-16.35-9.9-10.2-4.5-17.25-8.82-21.15-12.98-3.9-4.15-5.85-9.77-5.85-16.88,0-7.7,2.8-13.97,8.4-18.82,5.6-4.85,12.7-7.28,21.3-7.28s16.6,1.8,22.8,5.4l-1.5,10.35c-6.6-4.4-13.85-6.6-21.75-6.6-5.9,0-10.53,1.55-13.88,4.65-3.35,3.1-5.03,7-5.03,11.7s1.45,8.33,4.35,11.18c2.9,2.85,8.4,6.07,16.5,9.67,9.9,4.3,16.88,8.7,20.92,13.2,4.05,4.5,6.08,10.45,6.08,17.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.4,104.7h-10.35V1.2h10.35v103.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.35,104.7h-7.95l-60.45-87.15v87.15h-9.75V1.2h9.75l58.65,84.45V1.2h9.75v103.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.45,104.7h-55.5V1.2h54v9.45h-43.65v35.25h34.5l1.5,9.3h-36v40.05h45.15v9.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M537.89,77.4c0,8.7-3.03,15.63-9.08,20.77-6.05,5.15-13.72,7.73-23.03,7.73-10.1,0-19.25-2.15-27.45-6.45l1.5-10.5c8.1,5.2,16.9,7.8,26.4,7.8,6.2,0,11.3-1.67,15.3-5.02,4-3.35,6-7.88,6-13.58,0-5.1-1.5-9.2-4.5-12.3-3-3.1-8.45-6.4-16.35-9.9-10.2-4.5-17.25-8.82-21.15-12.98-3.9-4.15-5.85-9.77-5.85-16.88,0-7.7,2.8-13.97,8.4-18.82,5.6-4.85,12.7-7.28,21.3-7.28s16.6,1.8,22.8,5.4l-1.5,10.35c-6.6-4.4-13.85-6.6-21.75-6.6-5.9,0-10.53,1.55-13.88,4.65-3.35,3.1-5.03,7-5.03,11.7s1.45,8.33,4.35,11.18c2.9,2.85,8.4,6.07,16.5,9.67,9.9,4.3,16.88,8.7,20.92,13.2,4.05,4.5,6.08,10.45,6.08,17.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M613.34,77.4c0,8.7-3.03,15.63-9.08,20.77-6.05,5.15-13.72,7.73-23.03,7.73-10.1,0-19.25-2.15-27.45-6.45l1.5-10.5c8.1,5.2,16.9,7.8,26.4,7.8,6.2,0,11.3-1.67,15.3-5.02,4-3.35,6-7.88,6-13.58,0-5.1-1.5-9.2-4.5-12.3-3-3.1-8.45-6.4-16.35-9.9-10.2-4.5-17.25-8.82-21.15-12.98-3.9-4.15-5.85-9.77-5.85-16.88,0-7.7,2.8-13.97,8.4-18.82,5.6-4.85,12.7-7.28,21.3-7.28s16.6,1.8,22.8,5.4l-1.5,10.35c-6.6-4.4-13.85-6.6-21.75-6.6-5.9,0-10.53,1.55-13.88,4.65-3.35,3.1-5.03,7-5.03,11.7s1.45,8.33,4.35,11.18c2.9,2.85,8.4,6.07,16.5,9.67,9.9,4.3,16.88,8.7,20.92,13.2,4.05,4.5,6.08,10.45,6.08,17.85Z",
    style: {
      fill: "#fff"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeltaBusinessText);
export default __webpack_public_path__ + "static/media/delta-business-text.5123ca554a4095eabd4c809797ecce9b.svg";
export { ForwardRef as ReactComponent };